module.exports = __webpack_public_path__ + "img/c-12.e78b4e33.jpg";